var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckOrDoneMmmrForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49902 18.5C14.4696 18.5 18.499 14.4706 18.499 9.5C18.499 4.52944 14.4696 0.5 9.49902 0.5C4.52846 0.5 0.499023 4.52944 0.499023 9.5C0.499023 14.4706 4.52846 18.5 9.49902 18.5Z",
    fill: "url(#paint0_linear_14222_74850)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.14 6.99154L13.1278 5.97931C12.8857 5.73726 12.4896 5.73726 12.2256 5.97931L8.66078 9.56611L6.90038 7.80572C6.70234 7.60768 6.37226 7.60768 6.17422 7.80572L4.98595 8.99399C4.78791 9.19203 4.78791 9.5221 4.98595 9.72014L7.20845 11.9206L8.19868 12.9109C8.44073 13.1529 8.83681 13.1529 9.10087 12.9109L14.118 7.87173C14.36 7.62968 14.36 7.23359 14.118 6.96953L14.14 6.99154Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14222_74850",
    x1: 0.507161,
    y1: 9.5,
    x2: 18.499,
    y2: 9.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30C587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21A367"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOrDoneMmmrForm);
export default __webpack_public_path__ + "static/media/CheckOrDone_MMMR_Form.57b979a7fa630eeab426927b37c55ce7.svg";
export { ForwardRef as ReactComponent };